import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'avatar',
  pure: true
})
export class AvatarPipe implements PipeTransform {
  constructor(private userService: UserService) { }

  static cache: any = {};

  transform(userId: string, size: number = 28): Promise<string | void> {
    return AvatarPipe.cache[userId] ||
      (AvatarPipe.cache[userId] = this.userService.avatar(userId, size)
        .then(data => data)
        .catch(() => "/assets/images/clipart/avatar-1.svg?err"));
  }
}
